module.exports = __webpack_public_path__ + "static/media/YM10_1.04289868.jpg";